export const filterDropdownValues = [
  {
    id: 1,
    label: "Last 3 Days",
    value: "3days",
  },
  {
    id: 2,
    label: "Last 7 Days",
    value: "7days",
  },
  {
    id: 3,
    label: "Last 1 Month",
    value: "1month",
  },
  {
    id: 4,
    label: "Last 3 Months",
    value: "3months",
  },
  {
    id: 5,
    label: "Last 6 Months",
    value: "6months",
  },
  {
    id: 6,
    label: "Last 1 Year",
    value: "1year",
  },
  {
    id: 7,
    label: "Last 2 Years",
    value: "2years",
  },
];

export const chartFilterDropdownValues = [
  {
    id: 1,
    label: "Till date",
    value: "tillDate",
  },
  {
    id: 2,
    label: "Last 1 Month",
    value: "1month",
  },
  {
    id: 3,
    label: "Last 3 Months",
    value: "3months",
  },
  {
    id: 4,
    label: "Last 6 Months",
    value: "6months",
  },
  {
    id: 5,
    label: "Last 1 Year",
    value: "1year",
  },
  {
    id: 6,
    label: "Last 2 Years",
    value: "2years",
  },
];

export const regionFilterDropdownValues = [
  {
    id: 1,
    label: "ALL",
    value: "ALL",
  },
  {
    id: 2,
    label: "United Kingdom / Ireland",
    value: "United Kingdom / Ireland",
  },
  {
    id: 3,
    label: "Netherlands",
    value: "Netherlands",
  },
  {
    id: 4,
    label: "France",
    value: "France",
  },
  {
    id: 5,
    label: "Germany",
    value: "Germany",
  },
  {
    id: 6,
    label: "Australia / New Zealand",
    value: "Australia / New Zealand",
  },
  {
    id: 7,
    label: "NA",
    value: "NA",
  },
];

export const cfstDropDownFilterValues = [
  {
    id: 0,
    label: "Select Option",
    value: "",
  },
  {
    id: 1,
    label: "Last 5 Days",
    value: "last_5_days",
  },
  {
    id: 2,
    label: "Last 10 Days",
    value: "last_10_days",
  },
  {
    id: 3,
    label: "Last 15 Days",
    value: "last_15_days",
  },
  {
    id: 4,
    label: "Last 20 Days",
    value: "last_20_days",
  },
  {
    id: 5,
    label: "Last 30 Days",
    value: "last_30_days",
  },
  {
    id: 6,
    label: "Last 2 Months",
    value: "last_2_months",
  },
  {
    id: 7,
    label: "Last 3 Months",
    value: "last_3_months",
  },
  {
    id: 8,
    label: "Last 6 Months",
    value: "last_6_months",
  },
  {
    id: 9,
    label: "Last 1 Year",
    value: "last_1_year",
  },
  {
    id: 10,
    label: "Last 2 Years",
    value: "last_2_years",
  },
];

export const cfstComparisonViewDropDownFilterValues = [
  {
    id: 1,
    label: "Last 2 Months",
    value: "last_2_months",
    text: "over the past 2 months",
  },
  {
    id: 2,
    label: "Last 3 Months",
    value: "last_3_months",
    text: "over the past 3 months",
  },
  {
    id: 3,
    label: "Last 6 Months",
    value: "last_6_months",
    text: "over the past 6 months",
  },
  {
    id: 4,
    label: "Last 1 Year",
    value: "last_1_year",
    text: "over the last year",
  },
  {
    id: 5,
    label: "Till Date",
    value: "till_date",
    text: "to date",
  },
];
